import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { Images16 } from '@cian/ui-kit/icons';
import { useSelector } from 'react-redux';
import { FullscreenGallery } from '../../components/FullscreenGallery';
import { Content } from '../../components/FullscreenGallery/Content';
import { IApplicationState } from '../../types/redux';
import { FullscreenGalleryHeaderContainer } from '../FullscreenGalleryHeader';
import { trackOpenFullscreenGallery } from './tracking';

export function FullscreenGalleryContainer() {
  const [isOpened, setOpenedState] = React.useState(false);

  const gallery = useSelector((state: IApplicationState) => state.galleryMedia);

  const onButtonClick = React.useCallback(() => {
    setOpenedState(true);
    trackOpenFullscreenGallery();
  }, [setOpenedState]);

  const onClose = React.useCallback(() => {
    setOpenedState(false);
  }, [setOpenedState]);

  return (
    <>
      <Button theme="stroke_white_secondary" onClick={onButtonClick} beforeIcon={<Images16 color="white_100" />}>
        Галерея Комплекса
      </Button>
      {isOpened && (
        <FullscreenGallery
          onClose={onClose}
          header={<FullscreenGalleryHeaderContainer onClose={onClose} />}
          content={<Content gallery={gallery} />}
        />
      )}
    </>
  );
}
